/**
 *
 * Asynchronously loads the component for ClientManagementPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
